var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    { staticClass: "footer", attrs: { fluid: "" } },
    [
      _c("sui-divider"),
      _c("div", [
        _c("p", { staticClass: "legal-notice" }, [
          _vm._v(
            " © " +
              _vm._s(_vm.currentYear) +
              " EverSource Wealth Advisors, LLC. All rights reserved."
          ),
          _c("br"),
          _vm._v(
            " Investment advice offered through EverSource Wealth Advisors, a Registered Investment Advisor. "
          ),
          _c("br"),
          _vm._v(
            " EverSource Wealth Advisors may only conduct business with residents of states in which it is properly registered. "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }